import $https from '@/utils/https'

// 患者端：获取常用科室
export function getRecommendDepts(loadingTxt) {
  return $https({
    url: '/api/hospInfo/findConsultDepart',
    method: 'POST',
    //  serviceId: 'app.queryConsultDoctor',
    param: {
      selectType: 1
    },
    loadingTxt
  })
}
// 患者端：获取咨询医生列表
export function getDoctorsList(params, pageParam, isLoading, loadingTxt) {
  return $https({
    url: '/api/hospInfo/queryConsultDoctor',
    method: 'POST',
    serviceId: 'app.queryConsultDoctor',
    pageParam: pageParam,
    param: params,
    isLoading,
    loadingTxt
  })
}
// 患者端：获取最近咨询医生列表
export function getHistoryDoctorsList (params, pageParam, isLoading) {
  return $https({
    url: '/api/hospInfo/queryDoctorRetreat',
    method: 'POST',
    //  serviceId: 'app.queryConsultDoctor',
    pageParam: pageParam,
    param: params,
    isLoading: isLoading
  })
}
// 患者端：获取咨询医生详情
export function getDoctorInfoDetail (params) {
  return $https({
    url: '/api/hospInfo/queryDoctorInfoDetail',
    method: 'POST',
    //    serviceId: 'app.queryConsultDoctor',
    param: params
  })
}

// 患者端：关注医生
export function followDoctor (params) {
  return $https({
    url: '/api/hospInfo/followDoctor',
    method: 'POST',
    //    serviceId: 'app.queryConsultDoctor',
    param: params
  })
}

//  患者端：筛选医院
export function getHosps (params, pageParam, isLoading = true) {
  return $https({
    url: '/api/hospInfo/findConsultHospital',
    method: 'POST',
    //  serviceId: 'app.queryConsultDoctor',
    pageParam: pageParam,
    param: params,
    isLoading: isLoading
  })
}

// 患者端：筛选科室
export function getDepts (params, pageParam) {
  return $https({
    url: '/api/hospInfo/findConsultDepart',
    method: 'POST',
    //    serviceId: 'app.queryConsultDoctor',
    pageParam: pageParam,
    param: params
  })
}

// 患者端: 获取医生每天排班详情
export function getSchedulDayList (params) {
  return $https({
    url: '/api/reservation/getSchedulDayList',
    method: 'POST',
    param: params
  })
}

// 患者端: 获取医生指定日期的排班列表
export function getSchedulList (params) {
  return $https({
    url: '/api/reservation/getSchedulList',
    method: 'POST',
    param: params
  })
}

//  患者端: 获取排班号源列表
export function getNumberList (params) {
  return $https({
    url: '/api/reservation/getNumberListBySchedulId',
    method: 'POST',
    param: params
  })
}
// 患者：下单预约视频判断当前时间是否下单
export function checkStatus (params) {
  return $https({
    url: '/api/consult/getInitiateConsultInfo',
    method: 'POST',
    param: params
  })
}

// 患者端：提交症状
export function submitCounsulation (params) {
  return $https({
    url: '/api/consult/submissionSymptomDesc',
    method: 'POST',
    //  serviceId: 'app.queryConsultDoctor',
    param: params
  })
}

// 患者端：获取症状描述列表
export function getSymptomDescList (params, pageParam) {
  return $https({
    url: '/api/consult/getSymptomDescList',
    method: 'POST',
    //  serviceId: 'app.queryConsultDoctor',
    pageParam: pageParam,
    param: params
  })
}

// 患者端：问诊支付
export function getCredential (params) {
  return $https({
    url: '/api/consult/pay',
    method: 'POST',
    param: params
  })
}

//  患者端：重新下单
export function againOrder (params) {
  return $https({
    url: '/api/consult/againOrder',
    method: 'POST',
    param: params
  })
}
//  患者端：免密注册接口
export function regPhone (params) {
  return $https({
    url: '/api/account/reg/phone',
    method: 'POST',
    param: params,
    toastType:1
  })
}

// 更新消息接口
export const msgUpdate = (params) => {
  return $https({
    url: '/api/cms/msg/update',
    method: 'POST',
    param: params,
    isLoading: false,
    showError: false
  })
}
// 诊前调查题目
export function questions (params) {
  return $https({
    url: '/api/base/quiz/template',
    method: 'POST',
    param: params
  })
}

//  患者端：用户登出接口
export function logout (params) {
  return $https({
    url: '/api/account/logout',
    method: 'POST',
    param: params
  })
}

// 提交问卷
export function submitQuiz (params) {
  return $https({
    url: '/api/base/quiz/answer',
    method: 'POST',
    param: params
  })
}

// 初始化参数
export function initalHosp (params) {
  return $https({
    url: 'api/base/initial',
    method: 'POST',
    param: params
  })
}
//获取用户协议
export function userAgreement(params) {
  return $https({
    url: 'api/base/userAgreement',
    method: 'POST',
    param: params
  })
}

// 获取医院列表
export function getHospList (params, pageParam) {
  return $https({
    url: 'api/hospInfo/findConsultHospital',
    method: 'POST',
    param: params,
    pageParam: pageParam
  })
}

// 获取地区过滤列表
export function getFilterList (params) {
  return $https({
    url: 'api/user/address/areaCode',
    method: 'POST',
    param: params
  })
}



// WEBPACK FOOTER //
// ./src/services/modules/patientEnd.js